<template>


     <v-container v-if="estado===null"  grid-list-md text-md-center style="padding:0px!important   ;">
                <v-layout row>
                    <v-flex md12 style="margin-top:2rem;">
                         <v-progress-circular
                              :size="100"
                              color="danger"
                              :width="7"
                              indeterminate
                            ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-container>
     <v-container v-else-if="estado===1"  grid-list-md text-md-center style="padding:0px!important   ;">
                <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-toolbar color="light-blue" dark>
                    <v-spacer></v-spacer>
                    <v-toolbar-title style="text-align:center;">
                            Datos a Completar
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
        </v-toolbar>

        <v-list two-line subheader>
           <v-list-tile  @click="irapersonales()">
            
            <v-list-tile-content>
              <v-list-tile-title>Datos Personales</v-list-tile-title>
              <v-list-tile-sub-title>Editar Datos Personales</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon v-if="personales" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

   
          <v-list-tile @click="irfotoperfil()">           

            <v-list-tile-content>
              <v-list-tile-title>Foto de Perfil</v-list-tile-title>
              <v-list-tile-sub-title>Editar Foto de Perfil</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="fotos" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="iradnidigital()">           

            <v-list-tile-content>
              <v-list-tile-title>DNI Digital</v-list-tile-title>
              <v-list-tile-sub-title>Editar DNI Digital</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="dni" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="iratitulo()">           

            <v-list-tile-content>
              <v-list-tile-title>Título Habilitante</v-list-tile-title>
              <v-list-tile-sub-title>Editar Título Habilitante</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="titulo" color="green lighten-1">info</v-icon>
                 <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

           <v-list-tile @click="iracargos()">           

            <v-list-tile-content>
              <v-list-tile-title>Cargos</v-list-tile-title>
              <v-list-tile-sub-title>Editar Cargos</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="cargos" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="iraniveles()">           

            <v-list-tile-content>
              <v-list-tile-title>Niveles</v-list-tile-title>
              <v-list-tile-sub-title>Editar Niveles</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="niveles" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="iramodalidades()">           

            <v-list-tile-content>
              <v-list-tile-title>Modalidades</v-list-tile-title>
              <v-list-tile-sub-title>Editar Modalidades</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="modalidades" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile @click="iraareas()">           

            <v-list-tile-content>
              <v-list-tile-title>Areas</v-list-tile-title>
              <v-list-tile-sub-title>Editar Areas</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="areas" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

<!--           <v-list-tile @click="iraestablecimientos()">           

            <v-list-tile-content>
              <v-list-tile-title>Establecimientos</v-list-tile-title>
              <v-list-tile-sub-title>Editar</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                 <v-icon v-if="establecimientos" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile> -->


<!--           <v-list-tile @click="iracircuitos()">           

            <v-list-tile-content>
              <v-list-tile-title>Circuitos</v-list-tile-title>
              <v-list-tile-sub-title>no  se</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple>
                <v-icon v-if="circuitos" color="green lighten-1">info</v-icon>
                <v-icon v-else color="grey lighten-1">info</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile> -->





        </v-list>



      </v-card>
    </v-flex>
  </v-layout>
    </v-container>
        <v-container v-else-if="estado===0"  grid-list-md text-md-center style="padding:0px!important   ;">
        <v-layout wrap row justify-space-around align-content-center style="background:white; padding-top:3%;">
           
            <v-flex md6 align-content-center align-self-center>
                  
                     <img :src="banneractualizar"/>
              
            </v-flex>
             <v-flex md6  style="padding:1% 3% 1% 3%;">
                <p style="font-size:1.2rem;font-weight: 600;text-align:left;"> Para poder certificar las capacitaciones aprobadas, será requisito obligatorio y excluyente que actualice los siguientes datos de su DNI: </p>
                <br>
                <br>
                <ul style="text-align:left!important;">
                    <li>Pre CUIL.</li>
                    <li>Pos CUIL.</li>
                    <li>Título.</li>
                    <li>Nombres y Apellidos completos.</li>
                    <li>Fecha de nacimiento.</li>
                    <li>Deberá además, subir un archivo de imagen que contenga ambas caras del DNI, para corroborar datos completos y correctos. </li>
                    </ul >
            </v-flex>
            </v-layout>
             <v-layout justify-center row wrap style="background:white;">
            <v-flex md3>
            </v-flex>
            <v-flex md6>
                    <v-checkbox style=""
                          v-model="checkbox"
                          label="Entiendo,verificare y actualizare los datos requeridos."
                          color="orange"
                          value="orange"
                           hide-details
                        >                        
                    </v-checkbox>
            </v-flex>
            <v-flex md3>
            </v-flex>
            </v-layout>            
             <v-layout justify-center row wrap style="background: #eeeeee; border: 1px solid #e3e3e3;">
            <v-flex md3>
            </v-flex>    
            <v-flex md6 >
                     <v-btn 
                                block                               
                                color="blue" 
                                :loading="cargando" 
                                @click="NotificadoSubmit()"
                                style="color:#fff"
                                v-bind:class="{bloqueado: !checkbox}"
                            >
                             Aceptar
                    </v-btn>
            </v-flex>
            <v-flex md3>
            </v-flex>    
                </v-layout>
    </v-container>
  <!--      
    <div>
        <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
       

    </div> -->
</template>


<script>
    import axios from 'axios';

    export default
    {
        data()
        {
            return{
                estado:          null,
                checkbox:        false,
                debecheck:       false,
                cargando:        false,
                alta:            false,
                snackbar:       false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text: 'Recuerda verficar y Actualizar tus Datos',
                banneractualizar: 'https://docentes.educaciondigitaltuc.gob.ar/assets/actulalizardatos.svg',
                personales:         false,
                fotos:              false,
                dni:                false,
                titulo:             false,
                Cargos:             false,
                niveles:            false,
                modalidades:        false,
                areas:              false,
                //establecimientos:   false,
                //circuitos:          false,

            }
        },
        methods:
        {   NotificadoSubmit()
            {  
                if(this.checkbox)
                {
                   
                      this.debecheck= false;

                        var params  = '';
                        var headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');

                        params = params + 'tkn=' + this.$cookies.get('PDTK');
                        params  = params + '&alta=1';

                        axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_actividad_notificar.php', params, {headers: headers})
                            .then(response => {
                                const datos         = response.data
                                this.estado         = datos['estado'];                                
                                this.error          = datos['error'];
                               
                                this.cargando       = false;
                                window.scrollTo(0,0);
                            })
                            .catch(e => {
                                this.error          = true;
                            })
                }else{
                     console.log("click apagado");
                    this.debecheck= true;
                }
            },
            irapersonales()
            {
                this.$router.push('/editar/personales');
            },
            /*iracontacto()
            {
                this.$router.push('/editar/personales');
            },*/
            irfotoperfil()
            {
                this.$router.push('/editar/foto');
            },
            iradnidigital()
            {
                this.$router.push('/editar/dni');
            },
            iratitulo()
            {
                this.$router.push('/editar/titulo');
            },
            iracargos()
            {
                this.$router.push('/editar/cargos');
            },
            iraniveles()
            {
                this.$router.push('/editar/niveles');
            },
            iramodalidades()
            {
                this.$router.push('/editar/modalidades');
            },
            iraareas()
            {
                this.$router.push('/editar/areas');
            },
            iraestablecimientos()
            {
                this.$router.push('/editar/establecimientos');
            },
            iracircuitos()
            {
                this.$router.push('/editar/circuitos');
            },
        },
       
        beforeMount()
        {
            this.snackbar = true;
            if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }   
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                params  = params + '&alta=0';
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_actividad_notificar.php', params, {headers: headers})
                    .then(response => {
                         const datos          = response.data
                         this.estado          = datos['estado'];
                         this.personales      = datos['personales'];
                         this.fotos           = datos['fotos'];
                         this.dni             = datos['dni'];
                         this.titulo          = datos['titulo'];
                         this.cargos          = datos['cargos'];
                         this.niveles         = datos['niveles'];
                         this.modalidades     = datos['modalidades'];
                         this.areas           = datos['areas'];
                        
                    })
                    .catch(e => {})
            }
        }

    };

</script>


<style>
    .bloqueado
    {
        background: #C3C3C3!important;
        cursor: not-allowed!important;
    }

    .pautas
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }

    .pautas:hover
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
        -webkit-box-shadow: 0px 10px 20px 0px rgba(50, 50, 50, 0.75);
        -moz-box-shadow:    0px 10px 20px 0px rgba(50, 50, 50, 0.75);
        box-shadow:         0px 10px 20px 0px rgba(50, 50, 50, 0.75);
    }

   .v-input__slot
   {
        background: white!important;
        text-align: center!important;
   }
   .v-progress-circular
    {
        margin: 1rem;
        color: #4591d3;
    }
</style>
